import { useState } from "react"
import { AuthFetchTGUIO } from "../../services/api";
import { notify } from "../../utils/utils";


export const useCompany = () => {
    const [ empresas, setEmpresas] = useState([]);

    const listarEmpresa = async () => {
        try
        {
            const response = await AuthFetchTGUIO(`/company`)
            if(response.isValid){
                setEmpresas(response.content);
            }
            else
            {
                setEmpresas([]);
                notify(response.exceptions[0].description, 'error');
            }

        }
        catch(error)
        {
            notify('Ocurrió un error en el servicio','error');
            console.log('Error: ',error)
        }
    }


    return{
        listarEmpresa,
        empresas,
        
    }
}